import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { reportStyles, reportWebStyles } from "./theme.js";
import { formatDate, formatDateTime } from "./rendering.js";
import { CleaningMaintenanceSectionComponent, ProblemsSectionComponent, ProcessRecordsSectionComponent, TemperaturesSectionComponent, } from "./sections-records.js";
import { InternalChecksSectionComponent, PhotosSectionComponent, } from "./sections-review.js";
import { BusinessRegistrationSectionComponent, CoverSectionComponent, PeopleTrainingSectionComponent, PlanSetupSectionComponent, SuppliersAllergensSectionComponent, } from "./sections-setup.js";
import { REPORT_SECTION_ORDER, } from "./types.js";
function ReportSectionComponent({ rdm, section, }) {
    switch (section.key) {
        case "cover":
            return _jsx(CoverSectionComponent, { rdm: rdm, section: section });
        case "business_registration":
            return (_jsx(BusinessRegistrationSectionComponent, { rdm: rdm, section: section }));
        case "plan_setup":
            return _jsx(PlanSetupSectionComponent, { rdm: rdm, section: section });
        case "people_training":
            return _jsx(PeopleTrainingSectionComponent, { rdm: rdm, section: section });
        case "suppliers_allergens":
            return _jsx(SuppliersAllergensSectionComponent, { rdm: rdm, section: section });
        case "temperatures":
            return _jsx(TemperaturesSectionComponent, { rdm: rdm, section: section });
        case "process_records":
            return _jsx(ProcessRecordsSectionComponent, { rdm: rdm, section: section });
        case "cleaning_maintenance":
            return (_jsx(CleaningMaintenanceSectionComponent, { rdm: rdm, section: section }));
        case "problems":
            return _jsx(ProblemsSectionComponent, { rdm: rdm, section: section });
        case "internal_checks":
            return _jsx(InternalChecksSectionComponent, { rdm: rdm, section: section });
        case "photos":
            return section.included && rdm.photos.included ? (_jsx(PhotosSectionComponent, { rdm: rdm })) : null;
    }
}
export function ReportDocument({ presentation = "print", pageHeaderLabel, rdm, sectionKeys, }) {
    const selected = sectionKeys ? new Set(sectionKeys) : null;
    const order = new Map(REPORT_SECTION_ORDER.map((key, index) => [key, index]));
    const sections = [...rdm.sections]
        .filter((section) => !selected || selected.has(section.key))
        .sort((left, right) => (order.get(left.key) ?? 0) - (order.get(right.key) ?? 0));
    return (_jsxs("article", { className: presentation === "web" ? "sp-report sp-report--web" : "sp-report", "data-rdm-version": rdm.rdm_version, children: [_jsx("style", { children: presentation === "web" ? reportWebStyles : reportStyles }), _jsxs("div", { className: "sp-report__page-header", "aria-hidden": "true", children: [rdm.business.location_name, " \u00B7 ", pageHeaderLabel ?? "Evidence report", " \u00B7", " ", formatDate(rdm.period.start), " \u2013 ", formatDate(rdm.period.end)] }), _jsx("div", { className: "sp-report__page-footer", "aria-hidden": "true", children: _jsxs("span", { children: ["Generated ", formatDateTime(rdm.generated_at, rdm.period.timezone), " \u00B7", " ", "Generated from records kept in SafePlate (safeplate.nz)."] }) }), sections.map((section) => (_jsx(ReportSectionComponent, { rdm: rdm, section: section }, section.key)))] }));
}
